/* eslint-disable react/no-danger */
import { Accordion } from 'react-bootstrap-accordion';
import { useAPI } from 'src/hooks';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';

const Footer = loadable(() => import('@com/footer/Footer'));
const Header = loadable(() => import('@com/header/Header'));
const TopSection = loadable(() => import('@com/TopSection'));
const LoadingContainer = loadable(() => import('@com/utils/LoadingContainer'));

function FAQ(): JSX.Element {
  const { t } = useTranslation();
  const { getFAQ } = useAPI();
  const { data, isError, isSuccess } = useQuery([getFAQ.name], () => getFAQ());

  return (
    <>
      <Header />
      <TopSection sectionName={t('faq.faq')} />

      <section className="content-container tf-section wrap-accordion">
        <LoadingContainer isError={isError} isSuccess={isSuccess}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2
                  className="mb-5 ct style-2 fs-30 mg-bt-10"
                  data-test="faq-subheader"
                >
                  {t('faq.howWorks')}
                </h2>
              </div>
              <div className="col-md-12">
                <div className="flat-accordion2">
                  {data?.map((item, index) => (
                    <div key={index} data-test={`faq-q${index + 1}`}>
                      <Accordion title={item.question}>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.answer,
                          }}
                        />
                      </Accordion>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </LoadingContainer>
      </section>
      <Footer />
    </>
  );
}

export default FAQ;
